/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} People_FilterInputs */

const th_people_filter = /** @type {(inputs: People_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`พิมพ์ชื่อ`)
};

const en_people_filter = /** @type {(inputs: People_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type a name`)
};

const ja_people_filter = /** @type {(inputs: People_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名前を入力`)
};

const zh_people_filter = /** @type {(inputs: People_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输入姓名`)
};

const es_people_filter = /** @type {(inputs: People_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escribe un nombre`)
};

const pt_people_filter = /** @type {(inputs: People_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digite um nome`)
};

const id_people_filter = /** @type {(inputs: People_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ketik nama`)
};

const fr_people_filter = /** @type {(inputs: People_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saisissez un nom`)
};

const tl_people_filter = /** @type {(inputs: People_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mag-type ng pangalan`)
};

const vi_people_filter = /** @type {(inputs: People_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gõ tên`)
};

const ko_people_filter = /** @type {(inputs: People_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이름 입력`)
};

const de_people_filter = /** @type {(inputs: People_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Namen eingeben`)
};

const ru_people_filter = /** @type {(inputs: People_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Введите имя`)
};

const tr_people_filter = /** @type {(inputs: People_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ad yazın`)
};

const it_people_filter = /** @type {(inputs: People_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scrivi un nome`)
};

const pl_people_filter = /** @type {(inputs: People_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wpisz imię`)
};

const uk_people_filter = /** @type {(inputs: People_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Введіть ім'я`)
};

const hi_people_filter = /** @type {(inputs: People_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नाम लिखें`)
};

const ar_people_filter = /** @type {(inputs: People_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اكتب اسمًا`)
};

const ms_people_filter = /** @type {(inputs: People_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taip nama`)
};

const bn_people_filter = /** @type {(inputs: People_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`নাম লিখুন`)
};

const zh_tw2_people_filter = /** @type {(inputs: People_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`輸入姓名`)
};

const zh_hk2_people_filter = /** @type {(inputs: People_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`輸入姓名`)
};

const ur_people_filter = /** @type {(inputs: People_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نام لکھیں`)
};

const fa_people_filter = /** @type {(inputs: People_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نامی بنویسید`)
};

const sw_people_filter = /** @type {(inputs: People_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Andika jina`)
};

const nl_people_filter = /** @type {(inputs: People_FilterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ een naam`)
};

/**
* | output |
* | --- |
* | "Type a name" |
*
* @param {People_FilterInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const people_filter = /** @type {((inputs?: People_FilterInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<People_FilterInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_people_filter(inputs)
	if (locale === "ja") return ja_people_filter(inputs)
	if (locale === "zh") return zh_people_filter(inputs)
	if (locale === "es") return es_people_filter(inputs)
	if (locale === "pt") return pt_people_filter(inputs)
	if (locale === "id") return id_people_filter(inputs)
	if (locale === "fr") return fr_people_filter(inputs)
	if (locale === "tl") return tl_people_filter(inputs)
	if (locale === "vi") return vi_people_filter(inputs)
	if (locale === "ko") return ko_people_filter(inputs)
	if (locale === "de") return de_people_filter(inputs)
	if (locale === "ru") return ru_people_filter(inputs)
	if (locale === "tr") return tr_people_filter(inputs)
	if (locale === "it") return it_people_filter(inputs)
	if (locale === "pl") return pl_people_filter(inputs)
	if (locale === "uk") return uk_people_filter(inputs)
	if (locale === "hi") return hi_people_filter(inputs)
	if (locale === "ar") return ar_people_filter(inputs)
	if (locale === "ms") return ms_people_filter(inputs)
	if (locale === "bn") return bn_people_filter(inputs)
	if (locale === "zh-TW") return zh_tw2_people_filter(inputs)
	if (locale === "zh-HK") return zh_hk2_people_filter(inputs)
	if (locale === "ur") return ur_people_filter(inputs)
	if (locale === "fa") return fa_people_filter(inputs)
	if (locale === "sw") return sw_people_filter(inputs)
	if (locale === "nl") return nl_people_filter(inputs)
	return en_people_filter(inputs)
});